export const APP_VERSION = "1.8.1";

export const UPDATE_NOTICE_ROLES = ["admin", "segreteria", "coordinatore"];
export const UPDATE_NOTICE_EXTRA_NAMES = ["paola"];

export const CHANGELOG = [
  {
    version: "1.8.1",
    date: "2 ottobre 2026",
    title: "Correzione permessi trattamenti",
    items: [
      "Segreteria e Coordinatore possono ora salvare correttamente le modifiche ai trattamenti.",
      "Allineati i permessi di creazione e modifica dei trattamenti con quelli operativi dei macchinari."
    ]
  },
  {
    version: "1.8.0",
    date: "1 ottobre 2026",
    title: "Ruoli operativi e messaggistica interna",
    items: [
      "Nuovo ruolo Coordinatore / Responsabile per la gestione operativa del centro.",
      "Sessione persistente con rinnovo automatico per Segreteria e Coordinatore.",
      "Profilo Fisioterapista ristretto a Calendario, Agenda e Pazienti.",
      "Segreteria e Coordinatore possono gestire medici, fisioterapisti, cassa, spese, pagamenti e report.",
      "Gestione macchinari aggiornata: visualizzazione, creazione e modifica per Segreteria e Coordinatore.",
      "Messaggistica interna dal megafono verso gruppi o singoli utenti con conferma “Ho letto”.",
      "Schermata permessi resa più leggibile e utilizzabile anche da mobile."
    ]
  },
  {
    version: "1.7.0",
    date: "25 settembre 2026",
    title: "Agenda, ricerca e avvisi operativi",
    items: [
      "Agenda ottimizzata con note complete al passaggio del mouse.",
      "Stampa Agenda in formato A4 orizzontale con riepilogo medici e colonne essenziali.",
      "Ricerca globale corretta per distinguere Medici e Fisioterapisti.",
      "Apertura diretta del professionista selezionato dalla ricerca.",
      "Introduzione degli avvisi operativi con popup giallo per la Segreteria."
    ]
  },
  {
    version: "1.6.0",
    date: "21 settembre 2026",
    title: "Copia e incolla appuntamenti",
    items: [
      "Aggiunta la funzione Copia/Incolla appuntamenti dal calendario.",
      "Controllo dei conflitti prima della copia.",
      "Reset automatico di stato, pagamento, check-in e check-out sul nuovo appuntamento.",
      "Comandi dedicati anche per l’utilizzo da smartphone."
    ]
  },
  {
    version: "1.5.0",
    date: "17 settembre 2026",
    title: "Slot medici e agenda ambulatoriale",
    items: [
      "Nuovo sistema di disponibilità e slot dedicato ai Medici.",
      "Prenotazione medica vincolata agli slot realmente disponibili.",
      "Gestione della durata predefinita degli slot per professionista.",
      "Visualizzazione parallela degli slot medici nel calendario.",
      "Statistiche giornaliere dei Medici nell’Agenda.",
      "Controlli aggiuntivi su modifica, spostamento e conflitti degli appuntamenti medici."
    ]
  },
  {
    version: "1.4.0",
    date: "17 settembre 2026",
    title: "Backup e protezione dei dati",
    items: [
      "Nuova sezione Backup riservata ai profili autorizzati.",
      "Creazione e download protetto degli archivi di backup.",
      "Persistenza dei backup sul server e controllo di integrità.",
      "Conservazione automatica degli ultimi cinque archivi."
    ]
  },
  {
    version: "1.3.0",
    date: "10 settembre 2026",
    title: "Produzione e hardening sicurezza",
    items: [
      "Configurazione del gestionale per il deploy stabile su VPS.",
      "Interventi post-audit su sicurezza, download documenti, IP reale e timezone Europe/Rome.",
      "Validazione più rigorosa dei file caricati e miglioramenti alle API.",
      "Correzioni Docker e configurazione persistente dell’ambiente di produzione."
    ]
  },
  {
    version: "1.2.0",
    date: "1 settembre 2026",
    title: "Permessi, sicurezza e documenti",
    items: [
      "Introduzione del profilo Fisioterapista con accesso limitato ai dati assegnati.",
      "Sistema di permessi granulari per sezione e azione.",
      "Comunicazioni interne configurabili.",
      "Login rafforzato con CAPTCHA e protezioni contro tentativi ripetuti.",
      "Storage documenti configurabile per locale, NAS, Google Drive e S3."
    ]
  },
  {
    version: "1.1.0",
    date: "31 agosto 2026",
    title: "Medici, calendario e interfaccia",
    items: [
      "Integrato il logo ufficiale LanuseiLAB nell’interfaccia e nella PWA.",
      "Migliorato il Check-in palestra con ingressi del giorno e check-out rapido.",
      "Aggiunta la sezione Medici / Ambulatorio.",
      "Gestione delle giornate ambulatoriali e disponibilità dei Medici.",
      "Calendario aggiornato per mostrare e prenotare correttamente le giornate dei Medici."
    ]
  },
  {
    version: "1.0.0",
    date: "31 agosto 2026",
    title: "Prima versione operativa",
    items: [
      "Prima versione completa del gestionale LanuseiLAB.",
      "Dashboard, Calendario, Agenda, Pazienti, Check-in e Palestra.",
      "Gestione Fisioterapisti, Macchinari, Documenti, Pagamenti, Spese e Cassa.",
      "Report, Impostazioni, ricerca globale e audit log.",
      "Applicazione responsive con frontend React, backend FastAPI e database MongoDB."
    ]
  }
];
